import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-images.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSImageLink = ({
  children
}) => {
  const childrenArray = React.Children.toArray(children).filter(child => React.isValidElement(child));
  if (childrenArray.length === 0) {
    return null;
  }
  const firstChild = childrenArray[0];
  const {
    className
  } = firstChild.props;
  const classList = getClassNameList('uitk-image-link', className);
  const clonedElement = React.cloneElement(firstChild, {
    className: classList
  }, jsx("span", {
    className: "is-visually-hidden",
    children: firstChild.props.children
  }));
  return clonedElement;
};
EGDSImageLink.displayName = 'EGDSImageLink';
export { EGDSImageLink };